import AlertService from '../common/alert/AlertService';

export default (message) => {
  AlertService.showWarning(message, { TTL: 15 });
};
